(() => {
  const viewport = document.getElementById("bootlegs-viewport");
  const world = document.getElementById("bootlegs-world");
  if (!viewport || !world) return;

  // Measure header height so viewport fills remaining space
  const header = document.querySelector("header");
  const headerH = header ? header.getBoundingClientRect().height : 0;
  document.documentElement.style.setProperty("--bootlegs-header-h", `${Math.round(headerH)}px`);

  const centerTile = world.querySelector("[data-center-tile='1']");
  const items = Array.from(world.querySelectorAll("[data-bootlegs-item='1']"));

  // Prevent browser-native image/link ghost dragging
  world.querySelectorAll("img, a").forEach((el) => {
    el.setAttribute("draggable", "false");
  });

  world.addEventListener("dragstart", (e) => {
    e.preventDefault();
  });

  const totalTiles = items.length + (centerTile ? 1 : 0);

  // Choose near-square grid, force odd dims so center is an actual cell
  const aspectBias = window.innerWidth > 768 ? 1.2 : 1.0;
  let cols = Math.ceil(Math.sqrt(totalTiles) * aspectBias);
  let rows = Math.ceil(totalTiles / cols);

  if (cols % 2 === 0) cols += 1;
  if (rows % 2 === 0) rows += 1;

  // Apply CSS vars
  world.style.setProperty("--cols", String(cols));

  // Center cell (1-based for CSS grid lines)
  const cx = Math.floor(cols / 2) + 1;
  const cy = Math.floor(rows / 2) + 1;

  // Slight jitter (VERY light)
  const jitterPx = window.innerWidth > 768 ? 6 : 4;
  const jitterRot = window.innerWidth > 768 ? 0.8 : 0.5;

  const mulberry32 = (seed) => () => {
    let t = (seed += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };

  const setJitter = (el, seed) => {
    const r = mulberry32(seed);
    const jx = (r() * 2 - 1) * jitterPx;
    const jy = (r() * 2 - 1) * jitterPx;
    const jr = (r() * 2 - 1) * jitterRot;
    el.style.setProperty("--jx", `${jx.toFixed(2)}px`);
    el.style.setProperty("--jy", `${jy.toFixed(2)}px`);
    el.style.setProperty("--jr", `${jr.toFixed(2)}deg`);
  };

  // Place center tile
  if (centerTile) {
    centerTile.style.gridColumn = String(cx);
    centerTile.style.gridRow = String(cy);
    setJitter(centerTile, 12345);
  }

  // Generate spiral positions around center for products
  const spiralCoords = (count) => {
    const coords = [];
    let x = cx, y = cy;
    let step = 1;

    const push = (nx, ny) => {
      if (nx >= 1 && nx <= cols && ny >= 1 && ny <= rows) coords.push([nx, ny]);
    };

    while (coords.length < count) {
      // right
      for (let i = 0; i < step; i++) {
        x += 1;
        push(x, y);
        if (coords.length >= count) return coords;
      }

      // down
      for (let i = 0; i < step; i++) {
        y += 1;
        push(x, y);
        if (coords.length >= count) return coords;
      }

      step += 1;

      // left
      for (let i = 0; i < step; i++) {
        x -= 1;
        push(x, y);
        if (coords.length >= count) return coords;
      }

      // up
      for (let i = 0; i < step; i++) {
        y -= 1;
        push(x, y);
        if (coords.length >= count) return coords;
      }

      step += 1;

      // Safety
      if (step > cols + rows) break;
    }

    return coords;
  };

  const coords = spiralCoords(items.length);

  items.forEach((el, i) => {
    const [gx, gy] = coords[i] || [1, 1];
    el.style.gridColumn = String(gx);
    el.style.gridRow = String(gy);
    setJitter(el, i + 999);
  });
  // Dynamically limit how far the user can pan into empty space
  const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

  let scrollBounds = null;

  const getScrollBounds = () => {
    const tiles = Array.from(world.querySelectorAll(".bootlegs-card, .bootlegs-center"));

    if (!tiles.length) {
      return {
        minLeft: 0,
        maxLeft: Math.max(0, world.scrollWidth - viewport.clientWidth),
        minTop: 0,
        maxTop: Math.max(0, world.scrollHeight - viewport.clientHeight),
      };
    }

    const styles = getComputedStyle(world);
    const cell = parseFloat(styles.getPropertyValue("--cell")) || 180;
    const gap = parseFloat(styles.getPropertyValue("--gap")) || 18;

    // This is how much “breathing room” is allowed at the edges.
    // Bigger number = user can pan farther into empty space.
    // Smaller number = tighter boundary.
    const edgeRoom = (cell + gap) * 0.8;

    let left = Infinity;
    let top = Infinity;
    let right = -Infinity;
    let bottom = -Infinity;

    tiles.forEach((tile) => {
      left = Math.min(left, tile.offsetLeft);
      top = Math.min(top, tile.offsetTop);
      right = Math.max(right, tile.offsetLeft + tile.offsetWidth);
      bottom = Math.max(bottom, tile.offsetTop + tile.offsetHeight);
    });

    const naturalMaxLeft = Math.max(0, world.scrollWidth - viewport.clientWidth);
    const naturalMaxTop = Math.max(0, world.scrollHeight - viewport.clientHeight);

    let minLeft = Math.max(0, left - edgeRoom);
    let maxLeft = Math.min(naturalMaxLeft, right + edgeRoom - viewport.clientWidth);

    let minTop = Math.max(0, top - edgeRoom);
    let maxTop = Math.min(naturalMaxTop, bottom + edgeRoom - viewport.clientHeight);

    // If content is smaller than the viewport in one direction, lock it around center
    if (minLeft > maxLeft) {
      const midLeft = clamp((left + right - viewport.clientWidth) / 2, 0, naturalMaxLeft);
      minLeft = midLeft;
      maxLeft = midLeft;
    }

    if (minTop > maxTop) {
      const midTop = clamp((top + bottom - viewport.clientHeight) / 2, 0, naturalMaxTop);
      minTop = midTop;
      maxTop = midTop;
    }

    return { minLeft, maxLeft, minTop, maxTop };
  };

  const refreshScrollBounds = () => {
    scrollBounds = getScrollBounds();
  };

  const clampScroll = () => {
    if (!scrollBounds) refreshScrollBounds();

    viewport.scrollLeft = clamp(viewport.scrollLeft, scrollBounds.minLeft, scrollBounds.maxLeft);
    viewport.scrollTop = clamp(viewport.scrollTop, scrollBounds.minTop, scrollBounds.maxTop);
  };
  // Start centered
  requestAnimationFrame(() => {
    viewport.scrollLeft = (world.scrollWidth - viewport.clientWidth) / 2;
    viewport.scrollTop = (world.scrollHeight - viewport.clientHeight) / 2;
  });

    // Drag-to-pan
  let isDown = false;
  let moved = false;
  let captured = false;
  let startX = 0;
  let startY = 0;
  let startSL = 0;
  let startST = 0;

  const DRAG_THRESH = 8;

  const suppressNextClick = () => {
    viewport.dataset.suppressClick = "1";
    setTimeout(() => {
      delete viewport.dataset.suppressClick;
    }, 150);
  };

  const endDrag = (e) => {
    if (!isDown) return;

    if (captured && e?.pointerId != null) {
      try {
        viewport.releasePointerCapture(e.pointerId);
      } catch (_) {}
    }

    isDown = false;
    captured = false;
    viewport.classList.remove("is-dragging");

    // Only suppress product click if the user actually dragged
    if (moved) {
      suppressNextClick();
    }
  };

  viewport.addEventListener("pointerdown", (e) => {
    // left mouse only, but touch/pen allowed
    if (e.pointerType === "mouse" && e.button !== 0) return;

    isDown = true;
    moved = false;
    captured = false;

    startX = e.clientX;
    startY = e.clientY;
    startSL = viewport.scrollLeft;
    startST = viewport.scrollTop;
  });

  viewport.addEventListener("pointermove", (e) => {
    if (!isDown) return;

    const dx = e.clientX - startX;
    const dy = e.clientY - startY;

    if (!moved && Math.hypot(dx, dy) > DRAG_THRESH) {
      moved = true;
      viewport.classList.add("is-dragging");

      // Only capture once it is confirmed to be a drag
      try {
        viewport.setPointerCapture?.(e.pointerId);
        captured = true;
      } catch (_) {}
    }

    if (!moved) return;

    // Stop native image/link ghost dragging only during real drag
    e.preventDefault();

    viewport.scrollLeft = startSL - dx;
    viewport.scrollTop = startST - dy;
  });

  viewport.addEventListener("pointerup", endDrag);
  viewport.addEventListener("pointercancel", endDrag);

  // Suppress anchor clicks after dragging, but allow normal product clicks
  world.addEventListener(
    "click",
    (e) => {
      if (viewport.dataset.suppressClick === "1") {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );
})();